var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-button',{staticClass:"firmware-download",attrs:{"disabled":_vm.downloading},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('firmware.info.download')))]),(_vm.downloadError)?_c('span',{staticClass:"text-danger firmware-download-error",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.$t('firmware_download_error')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }